import web3Singletone from '../configWeb3';
import { abi, networks } from '../../build_sidechain/contracts/Affiliates';
import { getFunctionOutputAbi, paramParser, getEventOutputAbi } from './contractHandle';

class Affiliates {
  // affiliateContract;
  // configWeb3;
  // privateKeyBase64;
  constructor(privateKeyBase64) {
    const web3 = web3Singletone.getWeb3(privateKeyBase64);
    this.publicAddress = web3Singletone.getPublicAddress(privateKeyBase64);
    this.affiliateContract = new web3.eth.Contract(abi, networks[web3Singletone.getNetwork()].address, {
      from: this.publicAddress
    });
  }

  async addProductRecommend(productId) {
    const addPR = await this.affiliateContract.methods.addProductRecommend(productId).send();
    const eventOutputAbi = await getEventOutputAbi('AddProductToRecommendList', abi);
    const addPREvent = {};
    if (addPR && addPR.events && addPR.events.AddProductToRecommendList) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, addPR.events.AddProductToRecommendList.returnValues);
        addPREvent[parserValue.key] = parserValue.value;
        return true;
      });
    }
    return addPREvent;
  }

  async getRecommendIds(page, limit, sortByDate) {
    const rawResult = await this.affiliateContract.methods.getRecommendIds(page, limit, sortByDate).call();
    return {
      data: rawResult[0].map(item => parseInt(item)),
      total: parseInt(rawResult[1])
    };
  }

  async getCurrentNumOfRecommendUsed() {
    const rawResult = await this.affiliateContract.methods.getCurrentNumOfRecommendUsed().call();
    return parseInt(rawResult);
  }

  async getTotalNumOfRecommend() {
    const rawResult = await this.affiliateContract.methods.getTotalNumOfRecommend().call();
    return parseInt(rawResult);
  }

  async getStatisticAffiliate() {
    const rawResult = await this.affiliateContract.methods.getStatisticAffiliate().call();
    const functionOutputAbi = await getFunctionOutputAbi('getStatisticAffiliate', abi);
    const functionComponents = functionOutputAbi[0].components;
    const result = {};
    functionComponents.forEach(eachParam => {
      const parserValue = paramParser(eachParam, rawResult);
      result[parserValue.key] = parserValue.value;
    });
    return result;
  }

  async getStatisticAffiliateOfProduct(productId) {
    const rawResult = await this.affiliateContract.methods.getStatisticAffiliateOfProduct(productId).call();
    const functionOutputAbi = await getFunctionOutputAbi('getStatisticAffiliateOfProduct', abi);
    const functionComponents = functionOutputAbi[0].components;
    const result = {};
    functionComponents.forEach(eachParam => {
      const parserValue = paramParser(eachParam, rawResult);
      result[parserValue.key] = parserValue.value;
    });
    return result;
  }

  async checkProductInRecommendList(productId) {
    return await this.affiliateContract.methods.checkProductInRecommendList(productId).call();
  }
}

export default Affiliates;
